import React, {PureComponent} from 'react';
import {Alert, Button, Form, Spinner, FormGroup, Label, Input, FormFeedback} from "reactstrap";
import {Formik} from "formik";
import * as yup from "yup";
import {requiredMessage} from "../../utils/form-validation";
import {IPenaltyAddFormRequest} from '../../models/Penalty';
import {sanitizeForm} from "../../utils/sanitize-form";
import NumberFormat from "react-number-format";


const schema = yup.object({
    name: yup.string().required(requiredMessage()),
    description: yup.string().required(requiredMessage()),
    price: yup.number().required(requiredMessage())
});

type PenaltyAddType = {
    addPenaltyForm: (form: IPenaltyAddFormRequest) => void
    changeLoading: boolean
    changeError: string
    cancelHandler?: () => void
}

class PenaltyAdd extends PureComponent<PenaltyAddType> {
    render() {
        const {addPenaltyForm, changeLoading, changeError, cancelHandler} = this.props;

        return (
            <Formik
                validationSchema={schema}
                onSubmit={(values) => {
                    const name = sanitizeForm(values.name);
                    const description = sanitizeForm(values.description);
                    const price = sanitizeForm(values.price);

                    const form = {
                        name,
                        description,
                        price
                    };

                    addPenaltyForm(form)
                }}
                initialValues={{
                    name: '',
                    description: '',
                    price: ''
                }}
            >
                {({
                      handleSubmit,
                      handleChange,
                      values,
                      touched,
                      errors,
                      setFieldValue
                  }) => (
                    <Form onSubmit={handleSubmit}>
                        <FormGroup>
                            <Label>Название <span className={'required'}>*</span></Label>
                            <Input
                                type="text"
                                name="name"
                                value={values.name}
                                onChange={handleChange}
                                invalid={touched.name && !!errors.name}
                            />
                            <FormFeedback>{errors.name}</FormFeedback>
                        </FormGroup>
                        <FormGroup>
                            <Label>Цена <span className={'required'}>*</span></Label>
                            <NumberFormat
                                name={'price'}
                                allowNegative={false}
                                decimalSeparator={false}
                                value={values.price}
                                onValueChange={({floatValue}) => setFieldValue('price', floatValue)}
                                invalid={touched.price && !!errors.price}
                                customInput={Input}
                            />
                            <FormFeedback>{errors.price}</FormFeedback>
                        </FormGroup>
                        <FormGroup>
                            <Label>Описание <span className={'required'}>*</span></Label>
                            <Input
                                tag="textarea"
                                type="text"
                                name="description"
                                value={values.description}
                                onChange={handleChange}
                                invalid={touched.description && !!errors.description}
                            />
                            <FormFeedback>{errors.description}</FormFeedback>
                        </FormGroup>
                        {changeError &&
                        (<Alert className={'mt-3'} color={'danger'}>
                            {changeError}
                        </Alert>)}
                        <div className={'text-right'}>
                            {cancelHandler &&
                            <Button color="light" onClick={cancelHandler} className={'mr-3'}>Отменить</Button>}
                            <Button type="submit" color={'primary'} disabled={changeLoading}>
                                {changeLoading &&
                                (<Spinner
                                    size="sm"
                                />)}
                                Создать
                            </Button>
                        </div>
                    </Form>
                )}
            </Formik>
        )
    }
}

export default PenaltyAdd;
